import 'uni-pages';import 'uni-h5';import App from './App'
import Vue from 'vue'


Vue.config.productionTip = false
App.mpType = 'app'

//请求
import api from 'api/api.js'
Vue.prototype.$api=api;

// 自定义方法
import fun from '@/utils/function.js'
Vue.prototype.$fun=fun;

// 引入uview组件库
import uView from '@/uni_modules/uview-ui'
Vue.use(uView)

// 路由封装
import routing from '@/static/routing.js';
Vue.prototype.$routing=routing;

// // 路由拦截
// import '@/api/index.js'

// 引入语言包
import {i18n} from './i18n/index.js'
Vue.prototype._i18n = i18n
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
    ...App
})
app.$mount()